.export {
  color: var(--primary-100);
  font-size: 1rem;
  width: 45px;
  text-decoration: none;
}

.icon {
  color: var(--primary-100);
  font-size: 1rem;
  text-decoration: none;
}

.instruction {
  text-align: center;
}

.iconEtape {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}

.detail {
  font-size: 1.2rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 500;
}

.obligatoire {
  color: var(--color-c2436f);
  font-weight: 600;
  font-size: 1.2rem;
}

.content {
  max-width: 1200px;
  margin: 15px auto;
  padding: 0 75px;
}

.pagetitle {
  font-weight: bolder;
  font-size: 2rem;
  color: var(--primary-100);
  padding: 30px 0px;
}
